import { useState } from 'react'
import { ReportView } from './ReportView'
import { ReportRepliesView } from './ReportRepliesView'

type ReportType = 'reviews' | 'replies'

export const ReportsView = () => {
  const [activeTab, setActiveTab] = useState<ReportType>('reviews')

  return (
    <div className="flex flex-col h-full">
      {/* Header with dropdown */}
      <div className="flex items-center justify-between px-8 pb-6 pt-8 border-searchBorder">
        <h1 className="text-2xl font-bold">Reports</h1>
        <select
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value as ReportType)}
          className="px-4 py-2 border border-searchBorder rounded-lg bg-white text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="reviews">Review Reports</option>
          <option value="replies">Reply Reports</option>
        </select>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'reviews' ? <ReportViewContent /> : <ReportRepliesViewContent />}
      </div>
    </div>
  )
}

// Wrapper components that render the content without the header
const ReportViewContent = () => {
  return (
    <div className="h-full">
      <ReportView hideHeader />
    </div>
  )
}

const ReportRepliesViewContent = () => {
  return (
    <div className="h-full">
      <ReportRepliesView hideHeader />
    </div>
  )
}
